import React, { useState } from 'react';
import uploadFile from '../../utilities/uploadFile';
import config from '../../config/config';
import BasicFormInput from './BasicFormInput';
import BasicFormSelect from './BasicFormSelect';
import BasicFormDateInput from './BasicFormDateInput';
import LoadingSpinner from './LoadingSpinner';
import { Link } from 'react-router-dom';
import axios from 'axios';

const meeting_types = ['Phone', 'Online', 'In-Person'];

function AddMeetingForm() {
  const [meeting_name, setName] = useState('');
  const [meeting_location, setLocation] = useState('');
  const [meeting_type, setType] = useState(meeting_types[0]);
  const [meeting_date_time, setDateTime] = useState(new Date());
  const [meeting_notes, setNotes] = useState('No notes included');
  const [meeting_id, setMeetingId] = useState('');

  // for file upload
  const [isLoaded, setIsLoaded] = useState(true);
  const [uploadFiles, setUploadFiles] = useState(null);

  const updateReference = {
    meeting_name: setName,
    meeting_location: setLocation,
    meeting_type: setType,
    meeting_date_time: setDateTime,
    meeting_notes: setNotes,
    meeting_files: setUploadFiles
  };

  async function addMeeting(newData) {
    await axios
      .post(config.apiURL + `/add_meeting`, newData, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then(async (res) => {
        console.log(res);
        // setIsLoaded(false);
        if (res) {
          const meeting_id_data = res.data.meeting_id.toString(); //probably be a json formatted obj or something
          setMeetingId(meeting_id_data);
          setIsLoaded(false);
          if (uploadFiles != null) {
            //Need to validated that this is a meeting_id
            for (let i = 0, numFiles = uploadFiles.length; i < numFiles; i++) {
              const file = uploadFiles[i];
              const s3Key = `/outreach/meetings/${meeting_id_data}/${file.name}`;
              let r = await uploadFile(s3Key, file);
              console.log(r);
            }
          }
          setIsLoaded(true);
          alert('Meeting record successfully added!');

          setUploadFiles(null);
        }
      });
  }

  function mySubmitHandler(event) {
    event.preventDefault();
    // Get form data
    const postData = {
      meeting_name: meeting_name,
      // date_time: makeLocalToUTC(meeting_date_time).toISOString(),
      //   the above was a partial fix to align the timestamp displayed in meeting table with the timestamp selected when adding a meeting
      // Currently when adding meeting, the value is in local timestamp
      // When fetched from API, the api slices off timezone info and client displays the sliced timestamp
      // Practically speaking the client in CST and possibly uses the sliced UTC timestamp as CST
      date_time: meeting_date_time.toISOString(),
      meeting_type: meeting_type,
      meeting_location: {
        String: meeting_location,
        valid: meeting_location ? true : false
      },
      notes: meeting_notes
    };

    // Post request
    addMeeting(postData);
  }

  function handleFilesChange(e) {
    const { files, name } = e.target;
    const synthEven = { target: { value: files, name } };
    myChangeHandler(synthEven);
  }

  function handleDateChange(name, value) {
    const synthEvent = {
      target: { name, value }
    };
    myChangeHandler(synthEvent);
  }

  function myChangeHandler(e) {
    let { value, name } = e.target;

    if (name !== 'meeting_date_time' && value.includes('/')) {
      alert(`Cannot use the character '/' for the ${name.replace('_', ' ')}.`);
      value = '';
    }
    updateReference[name](value);
  }

  if (isLoaded) {
    return (
      <div className='container all-center'>
        <div
          className='card text-center'
          style={{ background: '#54c5f1', width: '385px', height: '700px' }}
        >
          <form onSubmit={mySubmitHandler}>
            <h3 style={{ textDecoration: 'underline' }}>
              Complete the Add Meeting Form and hit submit:
            </h3>
            <div className='grid-container'>
              <div className='grid-item' style={{ width: '350px' }}>
                <BasicFormInput
                  label='*Meeting Name'
                  updateKey='meeting_name'
                  value={meeting_name}
                  onChange={myChangeHandler}
                />
                <BasicFormSelect
                  label='*Meeting Type'
                  updateKey='meeting_type'
                  value={meeting_type}
                  onChange={myChangeHandler}
                  options={meeting_types.map((type) => ({
                    label: type,
                    value: type
                  }))}
                />

                <BasicFormInput
                  label='Meeting Location'
                  updateKey='meeting_location'
                  value={meeting_location}
                  onChange={myChangeHandler}
                />
                <BasicFormDateInput
                  label='*Meeting Date/Time'
                  updateKey='meeting_date_time'
                  value={meeting_date_time}
                  format='MM/dd/yyyy h:mm aa'
                  onChange={(val) => handleDateChange('meeting_date_time', val)}
                />

                <label htmlFor='meeting-notes-input'>Meeting Notes</label>
                <textarea
                  id='meeting-notes-input'
                  name='meeting_notes'
                  onChange={myChangeHandler}
                  value={meeting_notes}
                  style={{
                    width: '100%',
                    marginBottom: '10px',
                    resize: 'vertical',
                    maxHeight: '200px'
                  }}
                />
                <label htmlFor='meeting-files-input'>Upload files</label>
                <br />
                <i>* Hold CRTL/CMD to select multiple files</i>
                <input
                  type='file'
                  id='meeting-files-input'
                  name='meeting_files'
                  multiple
                  onChange={handleFilesChange}
                  style={{
                    backgroundColor: 'white',
                    width: '100%',
                    marginBottom: '10px',
                    resize: 'vertical'
                  }}
                />
              </div>
            </div>
            <button
              className='btn btn-primary'
              type='submit'
              id='addMeetingBtn'
              style={{ marginTop: '40px' }}
            >
              Submit
            </button>

            <Link
              title={meeting_id ? `a` : 'Create meeting first to add attendees'}
              data-bttn-disabled={meeting_id ? false : true}
              disabled={meeting_id ? false : true}
              to={
                meeting_id
                  ? `/editAttendees/${encodeURIComponent(
                      meeting_name
                    )}/${encodeURIComponent(
                      meeting_date_time
                    )}/${encodeURIComponent(meeting_id)}`
                  : ''
              }
            >
              <button
                disabled={meeting_id ? false : true}
                className='btn btn-primary'
                style={{ marginTop: '40px', width: 'auto' }}
              >
                {meeting_id
                  ? `Add Attendees for ${meeting_name}`
                  : 'Add Attendees'}
              </button>
            </Link>
          </form>
        </div>
      </div>
    );
  } else if (!isLoaded) {
    return (
      <>
        <div>
          <h3 className='all-center'>Uploading files. Please wait...</h3>
          <LoadingSpinner />
        </div>
      </>
    );
  }
}

export default AddMeetingForm;
